import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* LIST — every administrator of the panel at once */
export const list = data => {
    const uri = `${env.startpoint}/admin/manager/list`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* SAVE — a new administrator or a change of one */
export const save = data => {
    const uri = `${env.startpoint}/admin/manager/save`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* REMOVE */
export const remove = data => {
    const uri = `${env.startpoint}/admin/manager/remove`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}
